module.exports = __webpack_public_path__ + "static/img/vista_eye_yellow.6182c32d.gif";